<script>
    import LySection from './LySection.svelte';

    /**
     * @type {{
     *      mt?: number | boolean | string,
     *      mb?: number | boolean | string,
     *      center?: boolean | string,
     *      children?: import("svelte").Snippet,
     * }}
     */
    let { mt = 0, mb = 0, center = false, children } = $props();
</script>

<LySection tag="p" {mt} {mb} addClass="text-sm text-black-400{center ? ' text-center' : ''}">
    {@render children?.()}
</LySection>
